import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectCompetitorsForSelect = createSelector(
  [selectCompetitorsSobState, selectConfigurationState],
  ({ competitorsForSelect }, { programType }) => competitorsForSelect[programType] || []
)
